import { TranslationBaseCardMessages, BaseCardMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationBaseCardMessages = {
  [BaseCardMessages.statusProgrammedLabelText]: "Entrega prevista",
  [BaseCardMessages.statusProgrammedPrefixText]: "daqui a",
  [BaseCardMessages.statusPreparingLabelText]: "Entrega aguardando liberação",
  [BaseCardMessages.statusInTransitLabelText]: "A caminho",
  [BaseCardMessages.statusInTransitPrefixText]: "há",
  [BaseCardMessages.statusInConstructionLabelText]: "Na obra",
  [BaseCardMessages.statusInConstructionPrefixText]: "há",
  [BaseCardMessages.statusInConstructionDescriptionText]: "Horário de chegada",
  [BaseCardMessages.statusDischargingLabelText]: "Descarregando",
  [BaseCardMessages.statusDischargingPrefixText]: "há",
  [BaseCardMessages.statusDischargingDescriptionText]:
    "Início do descarregamento",
  [BaseCardMessages.statusDeliveredLabelText]: "Duração da entrega",
  [BaseCardMessages.statusDeliveredDescriptionText]: "Horário de conclusão",
  [BaseCardMessages.statusCanceledLabelText]: "Entrega cancelada",
  [BaseCardMessages.statusInvoiceIssuedLabelText]: "Nota emitida",
  [BaseCardMessages.statusInvoiceIssuedPrefixText]: " ás ",
  [BaseCardMessages.volumeText]: "Volume",
  [BaseCardMessages.volumeTotalText]: "Volume contratado",
  [BaseCardMessages.volumeDeliveredText]: "Entregue",
  [BaseCardMessages.volumeRemainingText]: "Saldo",
  [BaseCardMessages.volumePriceText]: "Valor/m³",
  [BaseCardMessages.installmentNumberText]: "Parcela",
  [BaseCardMessages.installmentDueDateText]: "Vencimento",
  [BaseCardMessages.installmentSettlementDateText]: "Pagamento",
  [BaseCardMessages.installmentNetValueText]: "Valor",
  [BaseCardMessages.travelEquipmentText]: "Equipamento",
  [BaseCardMessages.travelPlateText]: "Placa",
  [BaseCardMessages.travelDriverText]: "Motorista",
  [BaseCardMessages.travelProgrammedText]: "Programado",
  [BaseCardMessages.travelDocumentNumberText]: "Remessa",
  [BaseCardMessages.travelLoadLabelText]: "Lacre",
  [BaseCardMessages.concreteRecipeText]: "Traço",
  [BaseCardMessages.contractLabelText]: "Contrato",
  [BaseCardMessages.contractDateText]: "Data",
  [BaseCardMessages.contractSellerText]: "Vendedor",
  [BaseCardMessages.invoiceContractLabelText]: "Contrato",
  [BaseCardMessages.invoiceContractDateText]: "Data",
  [BaseCardMessages.invoiceNumberText]: "Nº da fatura",
  [BaseCardMessages.invoiceDocumentTypeText]: "NFSe",
  [BaseCardMessages.invoiceTotalValueText]: "Valor total",
  [BaseCardMessages.certificateContractText]: "Contrato",
  [BaseCardMessages.certificateConcretingDateText]: "Data da concretagem",
  [BaseCardMessages.certificateDateText]: "Data do laudo",
  [BaseCardMessages.clientDocumentText]: "Documento",
  [BaseCardMessages.clientCreditLimitText]: "Limite de crédito",
  [BaseCardMessages.clientCreditLimitAvailableText]: "Crédito disponível",
  [BaseCardMessages.clientPendencyText]: "O cadastro está pendente por",
  [BaseCardMessages.permissionClientNameText]: "Cliente",
  [BaseCardMessages.permissionContractText]: "Contrato",
  [BaseCardMessages.permissionDataText]: "Data",
  [BaseCardMessages.concretingRequestConcretingConcreteBatchingPlantText]:
    "Usina de entrega",
  [BaseCardMessages.concretingRequestConcretingDateText]: "Data da programação",
  [BaseCardMessages.concretingRequestConcretingTimeText]: "Hora",
  [BaseCardMessages.concretingRequestConcretingIntervalText]: "Intervalo",
  [BaseCardMessages.concretingRequestObservationText]: "Observação",
  [BaseCardMessages.concretingRequestRequesterText]: "Solicitante",
  [BaseCardMessages.concretingRequestRequesterPhoneNumberText]: "Número de telefone do solicitante",
  [BaseCardMessages.concretingRequestConcreteRecipeRequestedQuantityText]:
    "Quantidade solicitada",
  [BaseCardMessages.concretingRequestConcretingRecipeContractedQuantityText]:
    "Quantidade contratada",
  [BaseCardMessages.concretingRequestConcretingRecipeBalanceAvailableText]:
    "Saldo disponível",
  [BaseCardMessages.concretingRequestConcreteRecipeQuantityPerConcreteMixerText]:
    "Quantidade por betoneira",
  [BaseCardMessages.concretingRequestConcreteRecipePieceToBeConcretedText]:
    "Peça a ser concretada",
  [BaseCardMessages.concretingRequestPumpDescriptionText]: "Bomba",
  [BaseCardMessages.concretingRequestPipingDistanceText]: "Distância da tubulação (m)",
  [BaseCardMessages.concretingResumeCanceled]: "Cancelado",
  [BaseCardMessages.concretingResumeDelivered]: "Entregue",
  [BaseCardMessages.concretingResumeDischarging]: "Descarregando",
  [BaseCardMessages.concretingResumeInConstruction]: "Na obra",
  [BaseCardMessages.concretingResumeInTransit]: "A caminho",
  [BaseCardMessages.concretingResumeNFSE]: "Nota emitida",
  [BaseCardMessages.concretingResumePreparing]: "Aguardando",
  [BaseCardMessages.concretingResumeProgrammed]: "Programado",
  [BaseCardMessages.mapTextAgo]: " atrás",
  [BaseCardMessages.mapTextLastUpdate]: "Última atualização ",
  [BaseCardMessages.mapTextNameLabel]: "Nome"
};
